import { render, staticRenderFns } from "./boleto-loader.vue?vue&type=template&id=71c40d5c&scoped=true&"
import script from "./boleto-loader.vue?vue&type=script&lang=js&"
export * from "./boleto-loader.vue?vue&type=script&lang=js&"
import style0 from "./boleto-loader.vue?vue&type=style&index=0&id=71c40d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c40d5c",
  null
  
)

export default component.exports